import MechanismOption from './MechanismOption'
import {
  MFA_SETTINGS_RECOVERY_CODES_DESCRIPTION,
  MFA_SETTINGS_RECOVERY_CODES_RENEW,
  MFA_SETTINGS_RECOVERY_CODES_TITLE,
} from '../../constants/ui.labels'
import Button from '@talkdesk/cobalt-react-button'
import Box from '@talkdesk/cobalt-react-box'
import Card from '@talkdesk/cobalt-react-card'
import Flex from '@talkdesk/cobalt-react-flex'

const settings = {
  icon: 'vpn_key',
  name: MFA_SETTINGS_RECOVERY_CODES_TITLE,
  description: MFA_SETTINGS_RECOVERY_CODES_DESCRIPTION,
  isActive: false,
  defaultColor: 'orange',
}

const RenewButton = ({ onRenew }) => (
  <Button
    htmlType='button'
    type='secondary'
    onClick={onRenew}
    size='small'
    shape='full-width'
  >
    {MFA_SETTINGS_RECOVERY_CODES_RENEW}
  </Button>
)

const RecoveryCodesOption = (props) => (
  <Card>
    <Box>
      <Flex gap='4' alignY='center' alignX='space-between'>
        <MechanismOption {...settings} />
        <Box paddingX='5'>
          <RenewButton {...props} />
        </Box>
      </Flex>
    </Box>
  </Card>
)

export default RecoveryCodesOption
